import React, { Component } from 'react';
import { Box, Button, Card, Grid, IconButton, Typography } from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline';
import CardPage from '../../../../commonModules/layouts/CardPage';
import { GroupRadio, SingleRadio } from '../../../../commonModules/MUI/RadioAndCheckbox';
import { toast } from 'react-toastify';
import axios from 'axios';
import { AddCircleOutlineRounded, ArrowBackRounded, ArrowDownwardRounded, ArrowForwardRounded, ArrowUpwardRounded, CenterFocusWeakRounded, RemoveCircleOutline } from '@material-ui/icons';
import PopUp from '../../../../commonModules/interface/PopUp';
import BlockInventoryDetails from './BlockInventoryDetails';
import GenerateQrCode from '../products/GenerateQrCode';
import { Alert, AlertTitle } from '@material-ui/lab';
import { isEmpty } from 'lodash-es';

const scale = 50; // 1 mètre = 50 pixels dans l'aperçu
const ZONES = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
const pastelColors = [
    "#90C2E7", "#B7D1A3", "#F0C987", "#FFDDC1", "#94D0CC", 
    "#B4A8BD", "#D3B99F", "#E7C4C7", "#9BBE7E", "#F4B5BD",
    "#F5E1A4", "#9CC6E7", "#D6D7A1", "#E0AFA0", "#E8CABA", 
    "#A4C8A2", "#A1B0D4", "#C6CC9E", "#F8C6B7", "#B6D4E0", 
    "#E5D6A7", "#F1C6CF", "#8DB9CA", "#E4C7D2",  "#B39EB5", "#F9CB9C"
];

class PreviewLoc extends Component {
    state = { 
        openZonePopup: false,
        showZone: {},
        showBlockInventory: {},
        openSectionPopup: false,
        local: {
            zones: []
        }
    }
    componentDidMount = async () => {
        let req = await fetch("/stocks/locals/details",{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({localID: this.props.id}),
            credentials: 'same-origin',
        })
        let res = await req.json()

        console.log("get local details", {res});
        if(res.error){
            console.log("get local details", res.error.error);
        } else {
            this.setState({
                local: res
            })    
        }
    }
    
    makeZones = () => {
        const { local_longueur, local_largeur, local_orientation, zones } = this.state.local;
        console.log('==============MAKE ALLEYS======================');
        
        let alleys = []
        let width = 0
        let height = 0
        
        if (local_orientation === "v") {
            let widthCalc = (local_longueur / zones.length * scale)
            width = `${widthCalc}px`
            height = "100%"
        } else {
            let heightCalc = (local_largeur / zones.length * scale)
            height = `${heightCalc}px`
            width = "100%"
        }
        console.log({width, height});

        // for (let index = 0; index < zones.length; index++) {
            zones.forEach(zone => {
                alleys.push(
                    <>
                    <Box 
                        style={{
                            width, 
                            height, 
                            textAlign:"center", 
                            backgroundColor: pastelColors[zone.zone_index],
                            border:"15px solid #dbd1ee"
                        }}
                        onClick={() => this.showZone(zone, pastelColors[zone.zone_index])}
                    >
                        {zone.sections.length > 0 ?
                            <Box
                                style={{
                                    width:"100%",
                                    height:"100%",
                                    display: (local_orientation === "h" && "flex"),
                                }}
                            >
                                {/* <b>ZONE {zone.zone_name}</b> */}
                                {this.makeSections(zone, pastelColors[zone.zone_index])}
                            </Box>
                        :
                            <b>Allée {zone.zone_name}</b>
                        }
                    </Box>
                    </>
                )
            })

        return alleys
    }
    
    makeSections = (zone, color) => {
        const { local_orientation, zones } = this.state.local;
        console.log('==============MAKE SECTIONS======================');

        let sections = []
        let sWidth = 0
        let sHeight = 0
        
        if (local_orientation === "v") {
            sWidth = '100%'
            // sHeight = `${(heightInPixels / zone.sections.length)}px`
            sHeight = `${(100 / zone.sections.length)}%`
        } else {
            // sWidth = `${(widthInPixels / zone.sections.length)}px`
            sWidth = `${(100 / zone.sections.length)}%`
            sHeight = "100%"
        }
        console.log({sWidth, sHeight});

        let sectionStyle = {
            width: sWidth, 
            height: sHeight, 
            textAlign:"center", 
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border:"4px solid #dbd1ee",
            borderRadius: "8px",
            cursor:"pointer"
        }
        // for (let index = 0; index < zone.sections.length; index++) {
        zone.sections.forEach( (section, index) => {
            sections.push(
                <Box 
                    p={1}
                    style={sectionStyle}
                    // onClick={() => this.showZone(zone, zone.zone_index, `Z${zone}–Se${index + 1}`, color)}
                >
                    <b>{zone.zone_name}—Se{index + 1}</b>
                </Box>
            )
        })
        
        return sections
    }
    makeSectionsFront = (zone) => {
        const { zones } = this.state.local;
        console.log('==============MAKE SECTIONS======================');
        console.log({ zone});

        let sections = []        
        let sWidth = `${(100 / zone.sections.length)}%`
        let sHeight = "100%"
        
        let sectionStyle = {
            // width: sWidth, 
            height: sHeight, 
            textAlign:"center", 
            // display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border:"6px solid lightgray",
            // borderRadius: "8px",
            cursor:"pointer"
        }
        // for (let index = 0; index < zone.sections.length; index++) {
            zone.sections.forEach( (section, index) => {
                sections.push(
                    <Box 
                        style={{
                            width: sWidth, 
                            textAlign:"center", 
                        }}                    
                    >
                        <Box p={1} style={{border:"1px solid lightgray"}}>
                            <Box>
                                <Typography variant="h6">
                                    <b>Section {index + 1}</b>
                                    {/* <b>Section {index + 1} | </b>
                                    <span>{section.section_name}</span> */}
                                    {/* <span>Z{zone}—Se{index + 1}</span> */}
                                </Typography>

                            </Box>
                        </Box>
                        <Box 
                            style={sectionStyle}                        
                        >
                            <Box style={{height: '100%'}}>
                                {this.makeLevels(section, pastelColors[zone.zone_index] )}
                            </Box>
                        </Box>
                    </Box>
                )
            })
            
        return sections
    }


    makeLevels = (section, zoneColor) => {
        console.log('==============MAKE LEVELS======================');

        let levels = []

        let sWidth = '100%'
        let sHeight = `${(100 / section.blocks.length)}%`
      
        let sectionStyle = {
            height: "100%", 
            textAlign:"center", 
            borderRadius: "8px",
            backgroundColor: zoneColor,
            // width: sWidth, 
            // border:"4px solid #dbd1ee",
        }


        // for (let index = 0; index < section.nb_levels; index++) {
            section.blocks.sort((a, b) => a.level - b.level).forEach( (block, index) => {
                levels.push(
                    <Box 
                        p={1} 
                        style={{ 
                            border: "1px dashed gray", 
                            backgroundColor: zoneColor, 
                            width: sWidth, 
                            height: sHeight
                        }}
                        onClick={() => this.showBlock(block)}
                    >
                        <Card
                            elevation={3} 
                            p={1}
                            style={sectionStyle}
                        >
                            <Typography variant="h6">Niveau {block.level}</Typography>
                            <br />
                            <b>{block.storage_name}</b>
                            {/* <b>Z{zone}—Se{sectionIndex + 1}—N{index}</b> */}
                        </Card>
                    </Box>
                )
            })
            
        return levels.reverse()
    }

    showZone =  (zone) => {
        this.setState({ showZone: zone, openZonePopup: true})
    }

    showBlock =  (block) => {
        this.setState({ showBlockInventory: block, openBlockInventory: true})
    }

    render() {
        const { openZonePopup, showZone, openBlockInventory, showBlockInventory, openSectionPopup} = this.state;
        const { local_longueur, local_largeur, local_orientation } = this.state.local;

        const borderWidth = 4
        return (
                <Box>
                    {this.state.openQR && !isEmpty(showBlockInventory) && 
                        <GenerateQrCode 
                            // {...this.props} // notif from here
                            handleClose={() => this.setState({openQR: false })} 
                            qrID={`${this.props.id}-${showBlockInventory.storage_name}`}
                            qrRef={showBlockInventory.storage_name}
                            title={showBlockInventory.storage_name}
                        />
                    }
                    {openZonePopup && 
                        <PopUp
                            title={openBlockInventory ? `Inventaire ${showBlockInventory.storage_name}` : `Allée ${showZone.zone_name} | Vue Face` }
                            maxWidth="lg"
                            // secondaryAction={ openBlockInventory && 
                            //     <IconButton
                            //         size="large"
                            //         onClick={() => this.setState({openQR: true })}
                            //         title="QR Code"
                            //     >
                            //         <CenterFocusWeakRounded />
                            //     </IconButton>
                            // }
                            close={ () => this.setState({ showZone: {}, openZonePopup: false, showBlockInventory: {}, openBlockInventory: false, openQR: false})}
                            appbar
                        >
                            { openBlockInventory ?
                                <BlockInventoryDetails
                                    block={showBlockInventory}
                                    localID={this.props.id}
                                    handleClose={ () => this.setState({ showBlockInventory: {}, openBlockInventory: false, openQR: false})}
                                    pItem={this.props.pItem}
                                    productName={this.props.productName}
                                />
                            :
                                <>
                                    {this.props.productName &&
                                        <Box
                                            p={3} 
                                        >
                                            <Alert severity="info">
                                                <AlertTitle>{this.props.productName}</AlertTitle>
                                                Choisissez un block pour ranger le produit
                                            </Alert>
                                        </Box>
                                    }
                                    <Box
                                        p={3} 
                                        style={{ display: 'flex', justifyContent: "center", minHeight: "500px"}}
                                    >
                                        {this.makeSectionsFront(showZone)}
                                    </Box>
                                </>
                            }
                        </PopUp>
                    }
                    
                    {(local_largeur + local_longueur) > 0 &&
                        <Card title="Aperçu" >
                            <Box style={{display:"flex", textAlign: 'center'}}>

                                <Box p={1} style={{textAlign: 'center', writingMode: "vertical-rl", display: 'flex', justifyContent:"space-around"}} >            
                                    <ArrowUpwardRounded/>{local_largeur} m <ArrowDownwardRounded />
                                </Box>
                                
                                <Box p={2} style={{overflow:"auto"}}>
                                    <Box p={1} style={{textAlign: 'center', display: 'flex', justifyContent:"space-around"}}>
                                        <ArrowBackRounded/> {local_longueur} m <ArrowForwardRounded />
                                    </Box>
                                    <Box 
                                        style={{ 
                                            width: `${local_longueur * scale + borderWidth*2}px`, 
                                            height: `${local_largeur * scale + borderWidth*2}px`, 
                                            border: `${borderWidth}px solid grey`, 
                                            display: (local_orientation === "v" ? "flex": "block") 
                                        }}
                                    >
                                        {this.makeZones()}
                                    </Box>
                                </Box>
                            </Box>

                        </Card>
                    }
                
                </Box>
        );
    }
}

export default PreviewLoc;